export default __webpack_public_path__ + "static/media/QRF.e68ca3be.jpeg";